<template>
  <v-container fluid class="px-0 pt-0">
    <v-row>
      <v-col cols="12" class="py-0">
        <MediaModeForm v-if="(currentUser.clientType === 'Media' || currentUser.clientType === 'Driblab')" :fields="mediaModeFields"
        :mediaMode="mediaMode" @mediaModeChange="onMediaModeChange($event)"
        :mediaModeData="mediaModeData" @mediaModeDataChange="onMediaModeDataChange($event)" selectorMode></MediaModeForm>
        <v-card v-if="showCardFilter" class="pb-2" elevation="0" outlined>
          <v-row class="mx-0 align-center">
            <v-col class="py-0 mt-5" cols="12" sm="12">
              <v-card-title class="pa-0 header-font" style="font-size: 22px;">{{ $t('general.filters') }}</v-card-title>
            </v-col>
            <v-col cols="12" md="6" class="py-1 my-2">
              <v-radio-group class="mt-0"
                v-model="teamModel"
                :column="$vuetify.breakpoint.xsOnly"
                :row="!$vuetify.breakpoint.xsOnly"
                hide-details
                dense
                @change="filterPasses('team')"
                v-if="gameData"
              >
                <template v-slot:label>
                  <div
                    class="mr-8 primary--text font-weight-bold body-1"
                  >{{$t('game.passMap.team')}}:</div>
                </template>
                <v-radio color="secondary" :label="gameData[0].teamName" :value="true">
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ gameData[0].teamName }}</span>
                  </template>
                </v-radio>
                <v-radio color="secondary" :label="gameData[1].teamName" :value="false">
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ gameData[1].teamName }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
              <v-skeleton-loader v-else type="text" class="mt-6 ml-lg-4"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="5" class="pb-2 pt-0 my-0"
              offset-sm="2"
              offset-md="0"
            >
              <v-range-slider
                :label="$t('game.passMap.minutes')"
                thumb-label
                v-model="minutes"
                :min="rangeMinutes[0]"
                :max="rangeMinutes[1]"
                step="1"
                hide-details
                :color="`secondary ${$vuetify.theme.dark ? 'lighten-3' : ''}`"
                class="align-center"
                @change="filterPasses('minutes')"
              >
                <template v-slot:label>
                  <div class="d-flex flex-column">
                    <span class="primary--text font-weight-bold body-1">{{ $t('game.passMap.minutes') }}</span>
                    <span class="body-2 subheader-font monospace-font">{{ `(${rangeMinutes[0]} - ${rangeMinutes[1]})` }}</span>
                  </div>
                </template>
              </v-range-slider>
            </v-col>
          </v-row>
          <v-row class="mx-0 align-center">
            <v-col cols="12" class="py-1 mt-2">
              <v-radio-group class="mt-0"
                v-model="passesType"
                :column="$vuetify.breakpoint.xsOnly"
                :row="!$vuetify.breakpoint.xsOnly"
                dense
                hide-details
                @change="filterPasses()"
              >
                <template v-slot:label>
                  <div
                    class="mr-8 primary--text font-weight-bold body-1"
                  >{{$t('game.passMap.select')}}:</div>
                </template>
                <v-radio color="secondary" :label="$t('game.passMap.all')" value="all">
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('game.passMap.all') }}</span>
                  </template>
                </v-radio>
                <v-radio color="secondary" :label="$t('game.passMap.attacking')" value="isAttacking">
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('game.passMap.attacking') }}</span>
                  </template>
                </v-radio>
                <v-radio color="secondary" :label="$t('game.passMap.defending')" value="isDefending">
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('game.passMap.defending') }}</span>
                  </template>
                </v-radio>
                <v-radio color="secondary" :label="$t('game.passMap.forwards')" value="isForward">
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('game.passMap.forwards') }}</span>
                  </template>
                </v-radio>
                <v-radio color="secondary" :label="$t('game.passMap.backwards')" value="isBackward">
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('game.passMap.backwards') }}</span>
                  </template>
                </v-radio>
                <v-radio color="secondary" :label="$t('game.passMap.sideways')" value="isSideways">
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('game.passMap.sideways') }}</span>
                  </template>
                </v-radio>
                <v-radio color="secondary" :label="$t('game.passMap.longBall')" value="isLongBall">
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('game.passMap.longBall') }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-divider class="mt-4 mr-2"></v-divider>
          <v-row>
            <v-col class="d-flex justify-end pt-2 pb-0 px-4" cols="12">
              <v-btn
                color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small
                :x-small="!$vuetify.breakpoint.xsOnly"
                v-on:click.native="saveAsPNG('PassMap')"
              >
                <v-icon small class="mr-1">file_download</v-icon>
                <span class>PNG</span>
              </v-btn>
              <v-btn color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small
                :x-small="!$vuetify.breakpoint.xsOnly" v-on:click.native="saveAsSVG()">
                <v-icon small>file_download</v-icon>
                <span>SVG</span>
              </v-btn>
              <v-btn
                color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small
                :x-small="!$vuetify.breakpoint.xsOnly"
                :loading="loadingExport"
                :disabled="!chartSize"
                v-on:click.native="onGenerateIFrameClick()"
              >
                <v-icon small class="mr-1"
                  >share</v-icon
                >
                <span>Embed</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-row v-if="!showCardFilter">
          <v-col cols="12" class="py-3 mx-auto">
            <v-btn-toggle
              tile group dense mandatory
              :color="`${darkMode ? 'lightSecondary' : 'secondary'}`"
              v-model="teamModel"
              @change="filterDataPassMap()"
            >
              <v-btn
                text
                small
                v-bind:value="true"
              > {{ homeTeamName }} </v-btn>
              <v-btn
                text
                small
                v-bind:value="false"
              > {{ awayTeamName }} </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="11"
            sm="11"
            md="11"
            lg="5"
            xl="6"
            class="ml-xs-6 pr-sm-1 pl-xl-3 pt-xl-7"
          >
            <div class="rounded text-center pa-2 pt-3" :class="$vuetify.theme.dark ? 'secondary' : 'primary'">
              <span class="white--text header-font" style="font-size: 18px;">{{$t('table.playerPassMapData.title')}}</span>
            </div>
            <v-data-table
              id="passMapTable"
              :headers="passingStatsHeader"
              :items="passingStatsItems"
              :items-per-page="$vuetify.breakpoint.xlOnly ? itemsPerPageData : 10"
              class="elevation-1 mt-3"
              dense
            >
              <template
                v-for="(h) in passingStatsHeader"
                v-slot:[`header.${h.value}`]="{ header }"
              >
                <v-tooltip top color="lightSecondary lighten-4" max-width="300" :key="header.value">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{h.text}}</span>
                  </template>
                  <span class="black--text body-1">{{h.tooltip}}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.playerName="{ item }">
                <a :class="$vuetify.theme.dark ? 'primary--text' : 'secondary--text text--darken-2'" :href="'/player/' + item.playerId">{{ item.playerName }}</a>
              </template>
              <template v-slot:item.pctPasses="{ item }">
                <span>{{ item.pctPasses }}%</span>
              </template>
              <template v-slot:item.xGChain="{ item }">
                <div class="w-100 h-100 d-flex align-center justify-center font-weight-bold" v-bind:style="{'background-color':getBackgroundColor(item,'xGChain')}"
                 v-bind:class="getTextColorClass(item,'xGChain')">
                  <span>{{ item.xGChain }}%</span>
                </div>
              </template>
              <template v-slot:item.xA="{ item }">
                <div class="w-100 h-100 d-flex align-center justify-center font-weight-bold" v-bind:style="{'background-color':getBackgroundColor(item,'xA')}"
                 v-bind:class="getTextColorClass(item,'xA')">
                  <span>{{ item.xA }}</span>
                </div>
              </template>
              <template v-slot:item.xT="{ item }">
                <div class="w-100 h-100 d-flex align-center justify-center font-weight-bold" v-bind:style="{'background-color':getBackgroundColor(item,'xT')}"
                 v-bind:class="getTextColorClass(item,'xT')">
                  <span>{{ item.xT }}%</span>
                </div>
              </template>
            </v-data-table>
          </v-col>
          <v-col
            cols="11"
            sm="11"
            md="12"
            lg="7"
            xl="6"
            id="chart"
            ref="chart"
            class="text-center pt-5"
          >
          <GameAvatarMedia v-if="avatarSize && mediaMode && game" :width="size" :height="avatarSize.height" :id="`${gameId}-${chartId}`" :game="game"
            :margin="margin" :titleLeft="mediaModeData.titleLeft" :titleRight="mediaModeData.titleRight"
            :leftColor="isWhite(mediaModeData.leftFillColor) ? mediaModeData.leftBorderColor : mediaModeData.leftFillColor"
            :rightColor="isWhite(mediaModeData.rightFillColor) ? mediaModeData.rightBorderColor : mediaModeData.rightFillColor"
            ref="gameAvatarMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
            type="passMap" :lineDistance="mediaModeData.lineLength" :avatarSize="mediaModeData.avatarSize" :lineWeight="mediaModeData.lineWeight"
            :titleFontSize="mediaModeData.titleFontSize" :titleFontWeight="mediaModeData.titleFontWeight"
            :subtitle="mediaModeData.subtitle" :subtitleFontSize="mediaModeData.subtitleFontSize" :subtitleFontWeight="mediaModeData.subtitleFontWeight"
            :subtitle2="mediaModeData.subtitle2" :subtitle2FontSize="mediaModeData.subtitle2FontSize" :subtitle2FontWeight="mediaModeData.subtitle2FontWeight"
            ></GameAvatarMedia>
            <PassMapChart
              v-if="size != 0 && filteredPasses.length > 0 && game"
              :id="`${gameId}-${teamId}-${chartId}`"
              :size="size"
              :margin="margin"
              :key="passMapKey"
              :passes="filteredPasses"
              :passesByPlayersName="passesByPlayersName"
              :playersAvgPosition="playersAvgPosition"
              :teamId="teamId"
              :teamFormation="teamFormation"
              :teamColor="teamModel ? mediaModeData.leftFillColor : mediaModeData.rightFillColor"
              :strokeColor="strokeColor"
              :teamName="teamModel ? mediaModeData.titleLeft : mediaModeData.titleRight"
              :minFrom="minutes[0]"
              :minTo="minutes[1]"
              :language="currentUserLanguage"
              :mediaMode="mediaMode"
              @sizeChange="onChartSizeChange($event)"
              @loaded="onLoaded($event)"
            />
            <DriblabSocialMedia v-if="game && avatarSize && size && mediaMode && mediaModeData.socialMedia"  :width="size" :height="50" :id="`${gameId}-${chartId}`"
            :margin="margin" ref="driblabSocialMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
            :fontSize="mediaModeData.socialMediaFontSize" :fontWeight="mediaModeData.socialMediaFontWeight"
            :logoCfg="mediaModeData.logo" :sponsor="mediaModeData.sponsor.dataUrl" type="finishingMap"></DriblabSocialMedia>
          </v-col>
        </v-row>
        <v-row>
          <v-col
          cols="11"
          sm="11"
          md="11"
          lg="5"
          xl="6"
          class="ml-xs-6 pr-sm-2 pl-sm-2 pl-xl-3 pt-xl-7"
          >
            <div class="rounded text-center pa-2 pt-3" :class="$vuetify.theme.dark ? 'secondary' : 'primary'">
              <span class="white--text header-font" style="font-size: 18px;">{{$t('table.connections.title')}}</span>
            </div>
            <v-data-table
              id="passMapConnectionsTable"
              :headers="connectionsHeader"
              :items="connectionsItems"
              :items-per-page="$vuetify.breakpoint.xlOnly ? itemsPerPageConnections : 10"
              class="elevation-1 mt-3"
              dense
            >
              <template v-slot:item.playerFrom="{ item }">
                <a :class="$vuetify.theme.dark ? 'primary--text' : 'secondary--text text--darken-2'" :href="'/player/' + playerNamePlayerIdMap[item.playerFrom]">{{ item.playerFrom }}</a>
              </template>
              <template v-slot:item.playerTo="{ item }">
                <a :class="$vuetify.theme.dark ? 'primary--text' : 'secondary--text text--darken-2'" :href="'/player/' + playerNamePlayerIdMap[item.playerTo]">{{ item.playerTo }}</a>
              </template>
            </v-data-table>
          </v-col>
          <v-col
            cols="11"
            sm="11"
            md="12"
            lg="7"
            xl="6"
            id="chart"
            ref="chart"
            class="text-center pt-5 pl-1"
          >
            <PassMatrix
              v-if="size != 0 && filteredPassesMatrix.length > 0 && game"
              :id="`${gameId}-${teamId}-${chartId}`"
              :size="size"
              :margin="margin"
              :key="passMatrixKey"
              :passes="filteredPassesMatrix"
              :homeTeamScore="game.homeTeamScore"
              :rivalTeamScore="game.awayTeamScore"
              :teamName="homeTeamName"
              :rivalTeamName="awayTeamName"
              :minFrom="minutes[0]"
              :minTo="minutes[1]"
              :themeDark="$vuetify.theme.dark"
              :language="currentUserLanguage"
              @loaded="onLoaded($event)"
            />
            <v-col v-if="size != 0 && filteredPassesMatrix.length > 0"
              class="py-0 pr-7 d-flex justify-end">
              <v-btn
                color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small
                :x-small="!$vuetify.breakpoint.xsOnly"
                v-on:click.native="saveAsPNG('PassMatrix')"
              >
                <v-icon small class="mr-1">file_download</v-icon>
                <span class>PNG</span>
              </v-btn>
            </v-col>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <ChartExportLinksModal ref="chartExportLinksModalRef" :title="`${game.homeTeamName} ${game.homeTeamScore} - ${game.awayTeamScore} ${game.awayTeamName}`" v-if="game"
    :subtitle="$t('game.header.gamePassMap')"></ChartExportLinksModal>
  </v-container>
</template>

<script>
import * as d3 from "d3";

import GameService from "../../services/game/game.service";
import PassMapChart from "../base/PassMapChart";
import PassMatrix from "../base/PassMatrix";
import MediaModeForm from "../base/MediaModeForm";
import DriblabSocialMedia from "../base/DriblabSocialMedia";
import Dictionary from "../../dictionary";
import GameAvatarMedia from "./GameAvatarMedia";
import { exportSvg, downloadPng,copyAndAppendElement} from "../../utils/exportToPNG";
import { getNeutralColors,userHasRole } from "../../utils/functions";
import ChartExportLinksModal from '../base/ChartExportLinksModal';
import { v4 } from 'uuid';
import UserChartService from '../../services/user-chart.service';
import DocumentService from '../../services/document.service';
import UserService from '../../services/user.service';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8081';

const API_URL = NODE_ENV === 'production' ? 'https://pro.driblab.com/embed-chart/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/embed-chart/'

export default {
  name: "GamePassMap",
  components: {
    PassMapChart,
    PassMatrix,
    MediaModeForm,
    GameAvatarMedia,
    DriblabSocialMedia,
    ChartExportLinksModal
  },
  props:{
    chartId:{
      type:Number,
      default: 0
    },
    gameId:{
      type:Number,
      required: true
    },
    showCardFilter: {
      type: Boolean,
      default: false
    },
    homeTeam: {
      type: Boolean,
      default: true
    },
  },
  watch: {
    "mediaMode": function(newVal, oldVal) {
      if(!this.mediaMode){
        this.mediaModeData = {leftBorderColor:"#3366FF",rightBorderColor:"#3366FF",bgColor:"#ffffff0",socialMedia:true,textColor:"#000000",logo:"color",
                      titleFontSize:"18",titleFontWeight:"900",subtitleFontSize:"14",subtitleFontWeight:"500",lineWeight:"2",lineLength:"180",avatarSize:"64"
                      ,subtitle2FontSize:"12",subtitle2FontWeight:"300",sponsor:{}}
        this.mediaModeData.subtitle = this.game.leagueName;
        this.mediaModeData.subtitle2 = this.$t("game.header.gamePassMap");
        this.mediaModeData.titleLeft = this.game.homeTeamName;
        this.mediaModeData.titleRight = this.game.awayTeamName;
        this.mediaModeData.leftFillColor = this.game.homeTeamColor ? this.game.homeTeamColor.replace("0x","#") : getNeutralColors('home')[0];
        this.mediaModeData.rightFillColor = this.game.awayTeamColor ? this.game.awayTeamColor.replace("0x","#") : getNeutralColors('away')[0];
        this.mediaModeData.leftBorderColor = this.game.homeTeamSecondColor ? this.game.homeTeamSecondColor.replace("0x","#") : getNeutralColors('home')[1];
        this.mediaModeData.rightBorderColor = this.game.awayTeamSecondColor ? this.game.awayTeamSecondColor.replace("0x","#") : getNeutralColors('away')[1];
        this.mediaModeData.sponsor.src = require(`@/assets/img/driblab_normal_color.png`);
        this.mediaModeData.sponsor.fallBackSrc = require(`@/assets/img/driblab_normal_color.png`);
      }
      this.mediaModeData.bgColor = this.mediaMode ? '#ffffff' : '#ffffff0';
      this.onWindowResize(null,false)
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentUserLanguage() {
      return this.$store.getters["auth/language"];
    },
    avatarSize(){
      return {
        width: this.size,
        height: this.size / 5.5
      }
    },
    lastSearchId() {
      return this.$store.state.auth.lastSearch;
    },
    darkMode(){
      return this.currentUser.darkMode || this.$vuetify.theme.dark;
    },
  },
  data() {
    return {
      size: 0,
      margin: null,
      game:null,
      teamId: 0,
      //True = Home team ; False = Away team
      teamModel: this.homeTeam,
      homeTeamName: "",
      awayTeamName: "",
      teamName: "",
      teamFormation: "",
      teamColor: "",
      strokeColor: "#FFFFFF",
      passMapKey: 0,
      passMatrixKey: 1000,
      passesType: "all",
      passes: null,
      passesByPlayersName: null,
      gameData: null,
      gameDataByTeam: null,
      filteredPasses: [],
      playersAvgPosition: [],
      minutes: [0, 120],
      rangeMinutes: [0,120],
      periodId: 0,
      itemsPerPageData: 15,
      itemsPerPageConnections: 15,
      chartsLoaded: [],
      connectionsHeader: [
        {
          text:
            Dictionary[this.$i18n.locale]["table"]["connections"]["playerFrom"],
          align: "center",
          value: "playerFrom",
          sortable: false
        },
        {
          text:
            Dictionary[this.$i18n.locale]["table"]["connections"]["playerTo"],
          align: "center",
          value: "playerTo",
          sortable: false
        },
        {
          text: Dictionary[this.$i18n.locale]["table"]["connections"]["passes"],
          align: "center",
          value: "numberOfPasses",
          sortable: true
        }
      ],
      connectionsItems: [],
      passingStatsHeader: [
        {
          text:
            Dictionary[this.$i18n.locale]["table"]["playerPassMapData"][
              "player"
            ],
          tooltip:
            Dictionary[this.$i18n.locale]["table"]["playerPassMapData"][
              "playerTooltip"
            ],
          width: "30%",
          align: "center",
          value: "playerName",
          sortable: true
        },
        {
          text:
            Dictionary[this.$i18n.locale]["table"]["playerPassMapData"][
              "passes"
            ],
          tooltip:
            Dictionary[this.$i18n.locale]["table"]["playerPassMapData"][
              "passesTooltip"
            ],
          width: "15%",
          align: "center",
          value: "totalPasses",
          sortable: true
        },
        {
          text:
            Dictionary[this.$i18n.locale]["table"]["playerPassMapData"][
              "passesPct"
            ],
          tooltip:
            Dictionary[this.$i18n.locale]["table"]["playerPassMapData"][
              "passesPctTooltip"
            ],
          width: "20%",
          align: "center",
          value: "pctPasses",
          sortable: true
        },
        {
          text:
            Dictionary[this.$i18n.locale]["table"]["playerPassMapData"]["xA"],
          tooltip:
            Dictionary[this.$i18n.locale]["table"]["playerPassMapData"][
              "xATooltip"
            ],
          width: "8%",
          align: "center",
          value: "xA",
          sortable: true
        },
        {
          text:
            Dictionary[this.$i18n.locale]["table"]["playerPassMapData"][
              "xG"
            ],
          tooltip:
            Dictionary[this.$i18n.locale]["table"]["playerPassMapData"][
              "xGTooltip"
            ],
          width: "8%",
          align: "center",
          value: "xGChain",
          sortable: true
        },
        {
          text:
            Dictionary[this.$i18n.locale]["table"]["playerPassMapData"]["xT"],
          tooltip:
            Dictionary[this.$i18n.locale]["table"]["playerPassMapData"][
              "xTTooltip"
            ],
          width: "19%",
          align: "center",
          value: "xT",
          sortable: true
        }
      ],
      passingStatsItems: [],
      playerNamePlayerIdMap: null,
      playerIdsWithMoreMinutesPlayed: [],
      mediaMode: false,
      mediaModeData: {leftBorderColor:"#3366FF",rightBorderColor:"#3366FF",bgColor:"#ffffff0",socialMedia:true,textColor:"#000000",logo:"color",
                      titleFontSize:"18",titleFontWeight:"900",subtitleFontSize:"14",subtitleFontWeight:"500",lineWeight:"2",lineLength:"180",avatarSize:"64"
                      ,subtitle2FontSize:"12",subtitle2FontWeight:"300",sponsor:{}},
      mediaModeFields: [
        {type:"color",label:"mediaMode.fillColorX",key:"leftFillColor",labelParams:[1],home:true},
        {type:"color",label:"mediaMode.fillColorX",key:"rightFillColor",labelParams:[2],away:true},
        {type:"text",label:"mediaMode.titleX",key:"titleLeft",labelParams:[1],home:true},
        {type:"text",label:"mediaMode.titleX",key:"titleRight",labelParams:[2],away:true},
        {type:"number",label:"mediaMode.titleFontSize",key:"titleFontSize",force:true},
        {type:"radio",label:"mediaMode.titleFontWeight",key:"titleFontWeight"
          ,options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}],force:true},
        {type:"text",label:"mediaMode.subtitle",key:"subtitle"},
        {type:"number",label:"mediaMode.subtitleFontSize",key:"subtitleFontSize"},
        {type:"radio",label:"mediaMode.subtitleFontWeight",key:"subtitleFontWeight"
          ,options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"text",label:"mediaMode.subtitleX",key:"subtitle2",labelParams:[2]},
        {type:"number",label:"mediaMode.subtitleFontSizeX",key:"subtitle2FontSize",labelParams:[2]},
        {type:"radio",label:"mediaMode.subtitleFontWeightX",key:"subtitle2FontWeight",labelParams:[2]
          ,options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"color",label:"mediaMode.textColor",key:"textColor"},
        {type:"color",label:"mediaMode.bgColor",key:"bgColor"},
        {type:"number",label:"mediaMode.avatarLineLength",key:"lineLength",force:true},
        {type:"number",label:"mediaMode.avatarLineWeight",key:"lineWeight",force:true},
        {type:"number",label:"mediaMode.avatarSize",key:"avatarSize",force:true},
        {type:"switch",label:"mediaMode.socialMedia",key:"socialMedia"},
        {type:"number",label:"mediaMode.socialMediaFontSize",key:"socialMediaFontSize",force:true},
        {type:"radio",label:"mediaMode.socialMediaFontWeight",key:"socialMediaFontWeight"
          ,options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}],force:true},
        {type:"image",label:"mediaMode.sponsor",key:"sponsor",force:true,aspectRatio:16/9,imageRestriction:'none',resizable:true,stencilSize:{width:300,height:300}}
      ],
      chartSize: null,
      filteredPassesMatrix: [],
      loadingExport: false,
    };
  },
  created() {
    window.addEventListener("resize", this.onWindowResize);
    this.loadGame();
    //Get all passes (home team and away team) just once
    GameService.getGamePassMapData(
      this.gameId,
      this.minutes[0],
      this.minutes[1],
      this.periodId
    ).then(playersPasses => {
      this.gameData = playersPasses.data;
      //Get Home and Away team name
      this.homeTeamName = this.gameData[0].teamName;
      this.awayTeamName = this.gameData[1].teamName;

      //Get Home or Away team game data
      this.gameDataByTeam = this.teamModel
        ? this.gameData[0]
        : this.gameData[1];
      //Get Avg Position of 11 players of selected team with more minutes played
      this.playersAvgPosition = this.gameDataByTeam.playersAvgPosition.slice(
        0,
        11
      );
      //Get 11 Player Ids of selected team with more minutes played
      this.playerIdsWithMoreMinutesPlayed = this.playersAvgPosition.map(
        function(player) {
          return player.playerId;
        }
      );

      this.filteredPasses = this.gameDataByTeam.playersPasses.filter(player =>
        this.playerIdsWithMoreMinutesPlayed.includes(player.playerFromId) && player.playerFromId != player.playerToId
      );

      this.filteredPassesMatrix = this.gameDataByTeam.playersPasses.filter(player =>
        player.playerFromId != player.playerToId
      );

      //Create map with playerId as Key and PlayerName as value
      this.createMapPlayerIdPlayerName(
        _.concat(
          this.gameData[0].playersAvgPosition,
          this.gameData[1].playersAvgPosition
        )
      );
      //Get Players Data
      this.passingStatsItems = this.gameDataByTeam.playersData;
      this.$emit("passingStats", this.passingStatsItems);
      this.updateTeamInfo();
      this.calculatePlayersConnections();

      this.setMinutes();
      UserService.putLastSearchRendered({id:this.lastSearchId});
    });
  },
  mounted: function() {
    this.mediaMode = (this.currentUser.mediaMode || this.currentUser.clientType === 'Media');
    setTimeout(() => (this.size = this.$refs.chart.clientWidth * 0.95), 100);
  },
  methods: {
    onWindowResize(e,force=false) {
      setTimeout(() => {
        force = force || (e && e.type === "resize");
        if (this.size != this.$refs.chart.clientWidth * 0.95) {
          this.size = this.$refs.chart.clientWidth * 0.95;
        }
        this.passMapKey += 1;
        this.passMatrixKey += 1;
        if(this.$refs.gameAvatarMediaRef){
          this.$refs.gameAvatarMediaRef.printD3(force)
        }
        if(this.$refs.driblabSocialMediaRef){
          this.$refs.driblabSocialMediaRef.printD3(force)
        }
        this.$forceUpdate();
      },100)
    },
    filterPasses(filterType) {
      let minFrom = this.minutes[0];
      let minTo = this.minutes[1];

      if (filterType == "minutes") {
        GameService.getAvgPlayersPositionsPassMap(
          this.gameId,
          minFrom,
          minTo,
          this.periodId,
          this.teamModel
        ).then(response => {
          //this.playersAvgPosition = response.data;
          let teamPosition = this.teamModel ? 0 : 1;
          //Get Avg Position of 11 players of selected team with more minutes played
          this.playersAvgPosition = response.data.slice(0, 11);
          //Update gameData array with new AvgPlayersPositions
          this.gameData[
            teamPosition
          ].playersAvgPosition = this.playersAvgPosition;
          //Get 11 Player Ids of selected team with more minutes played
          this.playerIdsWithMoreMinutesPlayed = this.playersAvgPosition.map(
            function(player) {
              return player.playerId;
            }
          );

          this.filteredPasses = this.filteredPasses.filter(player =>
            this.playerIdsWithMoreMinutesPlayed.includes(player.playerFromId) && player.playerFromId != player.playerToId
          );
          this.gameDataByTeam = this.teamModel
            ? this.gameData[0]
            : this.gameData[1];

          //Get Avg Position of 11 players of selected team with more minutes played
          this.playersAvgPosition = this.gameDataByTeam.playersAvgPosition.slice(
            0,
            11
          );
          //Get 11 Player Ids of selected team with more minutes played
          this.playerIdsWithMoreMinutesPlayed = this.playersAvgPosition.map(
            function(player) {
              return player.playerId;
            }
          );
          //Get passes from team selected (Home or Away) and just 11 players with more minutes played
          this.filteredPasses = this.gameDataByTeam.playersPasses.filter(
            player =>
              this.playerIdsWithMoreMinutesPlayed.includes(player.playerFromId)  && player.playerFromId != player.playerToId
          );
          this.filteredPassesMatrix = this.gameDataByTeam.playersPasses.filter(
            player =>
              player.playerFromId != player.playerToId
          );

          //Get Players Data
          this.passingStatsItems = this.gameDataByTeam.playersData;
          if (this.passesType !== "all") {
            this.filteredPasses = this.filteredPasses.filter(
              pass =>
                pass[this.passesType] === true &&
                pass.timeEvent.split(":")[0] >= minFrom &&
                pass.timeEvent.split(":")[0] < minTo && pass.playerFromId != pass.playerToId
            );
            this.filteredPassesMatrix = this.filteredPassesMatrix.filter(
              pass =>
                pass[this.passesType] === true &&
                pass.timeEvent.split(":")[0] >= minFrom &&
                pass.timeEvent.split(":")[0] < minTo && pass.playerFromId != pass.playerToId
            );
          } else {
            this.filteredPasses = this.filteredPasses.filter(
              pass =>
                pass.timeEvent.split(":")[0] >= minFrom &&
                pass.timeEvent.split(":")[0] < minTo && pass.playerFromId != pass.playerToId
            );
            this.filteredPassesMatrix = this.filteredPassesMatrix.filter(
              pass =>
                pass.timeEvent.split(":")[0] >= minFrom &&
                pass.timeEvent.split(":")[0] < minTo && pass.playerFromId != pass.playerToId
            );
          }
          this.calculatePlayersConnections();
          //Update key to render map again
          this.passMapKey += 1;
          this.passMatrixKey += 1;
        });
      } else {
        //Filter by Home(teamModel = true) or Away(teamModel = false) team
        this.gameDataByTeam = this.teamModel
          ? this.gameData[0]
          : this.gameData[1];

        //Get Avg Position of 11 players of selected team with more minutes played
        this.playersAvgPosition = this.gameDataByTeam.playersAvgPosition.slice(
          0,
          11
        );
        //Get 11 Player Ids of selected team with more minutes played
        this.playerIdsWithMoreMinutesPlayed = this.playersAvgPosition.map(
          function(player) {
            return player.playerId;
          }
        );
        //Get passes from team selected (Home or Away) and just 11 players with more minutes played
        this.filteredPasses = this.gameDataByTeam.playersPasses.filter(player =>
          this.playerIdsWithMoreMinutesPlayed.includes(player.playerFromId) && player.playerFromId != player.playerToId
        );
        this.filteredPassesMatrix = this.gameDataByTeam.playersPasses.filter(
          player =>
            player.playerFromId != player.playerToId
        );

        //Get Players Data
        this.passingStatsItems = this.gameDataByTeam.playersData;
        if (this.passesType !== "all") {
          this.filteredPasses = this.filteredPasses.filter(
            pass =>
              pass[this.passesType] === true &&
              pass.timeEvent.split(":")[0] >= minFrom &&
              pass.timeEvent.split(":")[0] < minTo && pass.playerFromId != pass.playerToId
          );
          this.filteredPassesMatrix = this.filteredPassesMatrix.filter(
            pass =>
              pass[this.passesType] === true &&
              pass.timeEvent.split(":")[0] >= minFrom &&
              pass.timeEvent.split(":")[0] < minTo && pass.playerFromId != pass.playerToId
          );
        } else {
          this.filteredPasses = this.filteredPasses.filter(
            pass =>
              pass.timeEvent.split(":")[0] >= minFrom &&
              pass.timeEvent.split(":")[0] < minTo && pass.playerFromId != pass.playerToId
          );
          this.filteredPassesMatrix = this.filteredPassesMatrix.filter(
            pass =>
              pass.timeEvent.split(":")[0] >= minFrom &&
              pass.timeEvent.split(":")[0] < minTo && pass.playerFromId != pass.playerToId
          );
        }
        this.calculatePlayersConnections();
        if (filterType == "team") {
          this.updateTeamInfo();
        }
        //Update key to render map again
        this.passMapKey += 1;
        this.passMatrixKey += 1;

        this.$forceUpdate();
      }
    },
    updateTeamInfo() {
      this.teamId = this.gameDataByTeam.teamId;
      this.teamName = this.gameDataByTeam.teamName;
      this.teamFormation = this.gameDataByTeam.formation;
      this.teamColor = this.gameDataByTeam.teamColor;
      this.playersAvgPosition = this.gameDataByTeam.playersAvgPosition.slice(
        0,
        11
      );
    },
    calculatePlayersConnections() {
      this.passesByPlayersName = this.filteredPasses.reduce((acc, p) => {
        if(p.playerFromId != p.playerToId){
          const pFrom = p.playerFromName;
          const pTo = p.playerToName;
          if (!(pFrom in acc)) {
            acc[pFrom] = {};
          }
          if (!(pTo in acc[pFrom])) {
            acc[pFrom][pTo] = 1;
          } else {
            acc[pFrom][pTo] += 1;
          }
        }
        return acc;
      }, {});

      let passesByPlayersNameMatrixTemp = this.filteredPassesMatrix.reduce((acc, p) => {
        if(p.playerFromId != p.playerToId){
          const pFrom = p.playerFromName;
          const pTo = p.playerToName;
          if (!(pFrom in acc)) {
            acc[pFrom] = {};
          }
          if (!(pTo in acc[pFrom])) {
            acc[pFrom][pTo] = 1;
          } else {
            acc[pFrom][pTo] += 1;
          }
        }
        return acc;
      }, {});

      this.connectionsItems = _.chain(passesByPlayersNameMatrixTemp)
        .map((passes, playerFrom) => {
          return _.map(passes, (numberOfPasses, playerTo) => {
            return { playerFrom, playerTo, numberOfPasses };
          });
        })
        .flatten()
        .orderBy("numberOfPasses", "desc")
        .value()
        .slice(0, 30);

      this.$emit("connections", this.connectionsItems);
    },
    //Create map with playerId as Key and PlayerName as value
    createMapPlayerIdPlayerName(avgPositions) {
      this.playerNamePlayerIdMap = avgPositions.reduce((acc, player) => {
        acc[player.playerName] = player.playerId;
        return acc;
      }, {});
    },
    saveAsPNG(type) {
      if(this.mediaMode){
         downloadPng(this.prepareSvgForMedia(type), `Driblab ${type} - ${this.game.homeTeamName} ${this.game.homeTeamScore}:${this.game.awayTeamScore} ${this.game.awayTeamName}.png`);
      }else{
        let svg = d3.select(`#pitch${type}${this.gameId}-${this.teamId}-${this.chartId}`).select("svg").node()
        downloadPng(svg,`Driblab ${type} - ${this.game.homeTeamName} ${this.game.homeTeamScore}:${this.game.awayTeamScore} ${this.game.awayTeamName}.png`);
      }
    },
    saveAsSVG() {
      if(this.mediaMode){
        exportSvg(this.prepareSvgForMedia('PassMap'), `Driblab PassMap - ${this.game.homeTeamName} ${this.game.homeTeamScore}:${this.game.awayTeamScore} ${this.game.awayTeamName}`);
      }else{
        let svg = d3.select(`#pitchPassMap${this.gameId}-${this.chartId}`)
        .select("svg").node()
         exportSvg(svg, `Driblab PassMap - ${this.game.homeTeamName} ${this.game.homeTeamScore}:${this.game.awayTeamScore} ${this.game.awayTeamName}`);
      }
    },
    getElementToExport(){
      if(this.mediaMode){
        return this.prepareSvgForMedia('PassMap');
      }else{
        let svg = d3.select(`#pitchPassMap${this.gameId}-${this.chartId}`)
          .select("svg").node()
       return svg;
      }
    },
    setMinutes(){
      let allPasses = _.reduce(this.gameData,(result,g) => {
        result = [...result,...g.playersPasses];
        return result;
      },[])
      let allMinutes = _.reduce(allPasses,(result,p) => {
        let minute = Number(_.split(p.timeEvent,':')[0]);
        result.push(minute);
        return result;
      },[])
      this.rangeMinutes[0] = 0;
      this.rangeMinutes[1] = _.max(allMinutes);
      this.minutes = this.rangeMinutes;
    },
    getBackgroundColor(item,property,inverted = false){
      let allData = _.map(this.passingStatsItems,(t) => t[property]);
      let max = _.max(allData);
      let data = item[property];
      let percentageOfColor = data / max;
      if(inverted){
        percentageOfColor = 1 - percentageOfColor;
      }
      return `rgba(51, 102, 255,${percentageOfColor})`
    },
    getTextColorClass(item,property,inverted = false){
      let allData = _.map(this.passingStatsItems,(t) => t[property]);
      let max = _.max(allData);
      let percentageOfColor = item[property] / max;
              if(inverted){
          percentageOfColor = 1 - percentageOfColor;
        }
      return percentageOfColor > 0.6 ? 'white--text' : 'primary--text';
    },
    onMediaModeChange(event){
      this.mediaMode = event;
    },
    onMediaModeDataChange(event){
      this.mediaModeData = {...event};
      setTimeout(() => {this.onWindowResize(null,this.mediaModeData.force);},666)
    },
    async loadGame(){
      let gameResponse = await GameService.getGame(this.gameId);
      this.game = gameResponse.data;

      this.mediaModeData.subtitle = this.game.leagueName;
      this.mediaModeData.subtitle2 = this.$t("game.header.gamePassMap");
      this.mediaModeData.titleLeft = this.game.homeTeamName;
      this.mediaModeData.titleRight = this.game.awayTeamName;
      this.mediaModeData.leftFillColor = this.game.homeTeamColor ? this.game.homeTeamColor.replace("0x","#") : getNeutralColors('home')[0];
      this.mediaModeData.rightFillColor = this.game.awayTeamColor ? this.game.awayTeamColor.replace("0x","#") : getNeutralColors('away')[0];
      this.mediaModeData.leftBorderColor = this.game.homeTeamSecondColor ? this.game.homeTeamSecondColor.replace("0x","#") : getNeutralColors('home')[1];
      this.mediaModeData.rightBorderColor = this.game.awayTeamSecondColor ? this.game.awayTeamSecondColor.replace("0x","#") : getNeutralColors('away')[1];
      this.mediaModeData.sponsor.src = require(`@/assets/img/driblab_normal_color.png`);
      this.mediaModeData.sponsor.fallBackSrc = require(`@/assets/img/driblab_normal_color.png`);
      this.mediaModeFields = _.map(this.mediaModeFields,(f) => {
        if(f.home){
          f.labelParams = [this.game.homeTeamName];
        }
        if(f.away){
          f.labelParams = [this.game.awayTeamName];
        }
        return f;
      })
      this.$forceUpdate();
    },
    prepareSvgForMedia(type){
      let parent = document.createElementNS('http://www.w3.org/2000/svg','svg');
      let heightAccum = 0;
      let yOffset = type == 'PassMatrix' ? 50 : 0;
      parent.style.background = this.mediaModeData.bgColor;

      //COPY HEADER
      copyAndAppendElement(parent,document.querySelector(`#gameAvatarMedia${this.gameId}-${this.chartId}SVG`),5,0)
      heightAccum += this.avatarSize.height;
      copyAndAppendElement(parent,document.querySelector(`#pitch${type}${this.gameId}-${this.chartId}SVG`),5,this.avatarSize.height)
      heightAccum += this.chartSize.height;
      if(this.mediaModeData.socialMedia){
        copyAndAppendElement(parent,document.querySelector(`#driblabSocialMedia${this.gameId}-${this.chartId}SVG`),5,this.avatarSize.height + this.chartSize.height + yOffset)
        heightAccum += 50 + yOffset;
      }
      parent.setAttribute("width",this.chartSize.width);
      parent.setAttribute("height",heightAccum);
      return parent;
    },
    onChartSizeChange(event){
      this.chartSize = event;
    },
    onLoaded(event){
      this.chartsLoaded.push(event);
      //Emit when both (map and matrix) are loaded
      if(this.chartsLoaded.length > 1){
        this.$emit("loaded", null);
        this.chartsLoaded.length = 0;
      }
    },
    isWhite(color){
      return color === "#FFF" || color === "#fff" || color === "#FFFFFF" || color === "#ffffff" || color === "white";
    },
    async onGenerateIFrameClick(){
      this.loadingExport = true;
      let elToExport = this.getElementToExport();
      let key = v4();
      key = `${key}.json`;
      let chartObject = {
        awsKey:key,
        tool: 'game-pass-map',
        category: 'game',
        componentId: this.gameId,
        width: elToExport.getAttribute("width"),
        height: this.mediaMode ? elToExport.getAttribute("width") * 0.9925 : elToExport.getAttribute("width") * 0.806
      }
      let postResponse = await UserChartService.postChart(chartObject)
      let chartEntity = postResponse.data;

      this.$refs.chartExportLinksModalRef.open(chartEntity);
      this.loadingExport = false;

      let urlResponse = await UserChartService.getUploadURL(chartEntity.id,key);
      let uploadUrl = urlResponse.data;
      var jsonse = JSON.stringify({
        size: Number(chartEntity.width),
        height: Number(chartEntity.height),
        passes: this.filteredPasses,
        passesByPlayersName: this.passesByPlayersName,
        playersAvgPosition:this.playersAvgPosition,
        teamId: this.teamId,
        teamFormation: this.teamFormation,
        teamColor: this.teamModel ? this.mediaModeData.leftFillColor : this.mediaModeData.rightFillColor,
        strokeColor: this.strokeColor,
        teamName:this.teamModel ? this.mediaModeData.titleLeft : this.mediaModeData.titleRight,
        minFrom:this.minutes[0],
        minTo:this.minutes[1],
        mediaModeData: this.mediaModeData,
        mediaMode: this.mediaMode,
        language: this.currentUserLanguage,
        playerAvatarKey: 0,
        key: this.passMapKey,
        socialMediaKey: 2,
        id: `${this.gameId}-${this.chartId}`,
        game:this.game,
        chartType:"game-pass-map",
        category: 'game',
      });

      var blob = new Blob([jsonse], {type: "application/json"});
      // let blob = exportSvgToFile(elToExport);
      let uploadResponse = await DocumentService.upload(uploadUrl,blob);
      this.postSearchChart(chartEntity)
    },
    async postSearchChart(chart){
      const authorized = true;
      let metaInfo = null;
      let category = "game";
      let urlId = this.gameId;

      metaInfo = JSON.stringify({
        link: `${API_URL}${chart.id}/key/${chart.awsKey}/compId/${chart.componentId}/catId/${chart.categoryId}/tId/${chart.toolId}`
      });
      const tool = 'embed';
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const browser = navigator.userAgent;
      let searchResponse = await UserService.postUserSearch(category, tool, urlId, authorized, this.$route.path, timeZone, browser, metaInfo);
      UserService.putLastSearchRendered({category,tool,id:searchResponse.data})
    },
    userHasRole(role) {
      return userHasRole(this.currentUser, role);
    },
  },
  destroyed() {
    d3.selectAll(".tooltip").remove();
    window.removeEventListener("resize", this.onWindowResize);
  }
};
</script>
<style lang="scss">
#passMapTable,
#passMapConnectionsTable {
  td, th {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
}
</style>
<style>
body > div.tooltip {
  font-family: "NeueMontreal";
  pointer-events: none;
  position: absolute;
  background: none repeat scroll 0 0 #ffffff;
  padding: 5px 10px 5px 10px;
  border-radius: 4px;
  text-align: center;
  display: none;
  line-height: 1.5;
  color: #081f2c;
  box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.15);
}

body > div.tooltip:after {
  box-sizing: border-box;
  display: block;
  width: 100%;
  line-height: 2.8;
  color: #ffffff;
  content: "\25BC";
  text-align: center;
}

body > div.nwTooltip {
  font-family: "NeueMontreal";
  pointer-events: none;
  position: absolute;
  background: none repeat scroll 0 0 #ffffff;
  padding: 5px 10px 5px 10px;
  border-radius: 4px;
  text-align: center;
  display: none;
  line-height: 1.5;
  color: #081f2c;
  box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.15);
}

body > div.nwTooltip:after {
  box-sizing: border-box;
  display: block;
  width: 100%;
  line-height: 2.8;
  color: #ffffff;
  content: "\25BC";
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/game/GamePassMap.vue